module.exports = __webpack_public_path__ + "static/SAYGRACE-1f533f714e0cc4094b34bb7cadcb0e25.png";